function home() {
    return document.body.classList.contains('home');
}

export { home };
